export class NativeStreamOutputField {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamMapOutputKind",
            "format": ""
        },
        {
            "name": "fields",
            "baseName": "fields",
            "type": "Array<NativeStreamOutputField>",
            "format": ""
        },
        {
            "name": "items",
            "baseName": "items",
            "type": "NativeStreamOutputType",
            "format": ""
        },
        {
            "name": "keys",
            "baseName": "keys",
            "type": "NativeStreamMapKeyType",
            "format": ""
        },
        {
            "name": "values",
            "baseName": "values",
            "type": "NativeStreamOutputType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamOutputField.attributeTypeMap;
    }
    constructor() {
    }
}
